<template>
    <Editor :init="mergedInit" v-bind="$attrs" v-on="$listeners"/>
</template>

<script>
   import api from "../utils/api";
   import func from "../utils/func";
   import Editor from '@tinymce/tinymce-vue';

   export default {
      name: "TinymceEditor",
      components: {Editor},
      props: {
         init: Object,
         height: {
            type: Number,
            default: 540,
         }
      },
      data() {
         return {
            mergedInit: {}
         }
      },
      created() {
         let plugins = [
            // 'importcss', 'searchreplace','visualblocks', 'visualchars','noneditable',
            // 'autolink', 'autosave', 'save', 'directionality','hr', 'nonbreaking','toc', 'textpattern',
            'image', 'preview', 'fullscreen', 'link', 'media',
            'table', 'anchor', 'advlist', 'lists', 'wordcount', 'emoticons'
         ];
         let toolbar = [
            "font", "align", "typeset",
            "image media link",
            "fullscreen preview"
         ];
         let defaultInit = {
            height: this.height,
            menubar: false,
            branding: false,
            language: "zh_CN",
            plugins: plugins.join(" "),
            toolbar: toolbar.join(" | "),
            toolbar_groups: {
               font: {
                  text: "字体",
                  items: "fontselect fontsizeselect formatselect forecolor backcolor bold italic underline strikethrough removeformat",
               },
               align: {
                  text: "对齐",
                  items: "alignleft aligncenter alignright alignjustify"
               },
               typeset: {
                  text: "排版",
                  items: "table numlist bullist outdent indent"
               }
            },
            content_style: "p {margin: 0px;}",
            images_upload_handler: function (info, success, failure) {
               api.v1.resource.create({
                  public: true,
                  content: info.base64(),
                  suffix: func.extension(info.filename())
               }).then(res => {
                  success(func.imageUrl(res.id));
               }).catch(() => {
                  failure("图片上传失败");
               });
            }
         };
         this.mergedInit = Object.assign({}, defaultInit, this.init);
      }
   }
</script>
